import { css } from '@emotion/react';

import { ReactNode } from 'react';

import { Spacing } from 'chatie-design-system';

import { responsiveMaxWidth, safeArea } from '../../styles/css';
import { CSSProps, OnClickProps } from '../../utils/misc';
import Push, { PushSize } from '../layout/Push';
import Button, { ButtonProps } from './Button';

const bottomButtonCSS = css`
  position: fixed;
  width: 100%;
  ${responsiveMaxWidth};
  bottom: 0;
  padding: ${Spacing.medium}px;
  ${safeArea('bottom', 'padding', Spacing.medium)}
  z-index: 9;

  @media (max-height: 340px) {
    display: none;
  }
`;

type Props = {
  push?: boolean;
  children?: ReactNode;
  pushSize?: number;
};

const BottomButton = ({
  className,
  push = false,
  children,
  pushSize = PushSize.bottomButton,
  ...props
}: Props & CSSProps & ButtonProps & OnClickProps) => {
  return (
    <>
      {push && <Push bottom size={pushSize} />}
      <div className={className} css={bottomButtonCSS}>
        <Button {...props}>{children}</Button>
      </div>
    </>
  );
};

export default BottomButton;
